import { Link } from 'react-router-dom'
import styles from './HostServiceCard.module.css'
import { Box, Button } from '@mui/material'
import { useStartSpyHostServiceMutation, useStopSpyHostServiceMutation } from '../../../../../../../services/propertySpy'

interface HostServiceCardProps {
    hostServiceInformation?: any,
    marketSpyId?: number,
    onStartSpyHostService?: (hostService: any) => void
}

export const HostServiceCard = (props: HostServiceCardProps): JSX.Element => {
    const {
        hostServiceInformation,
        marketSpyId,
        onStartSpyHostService
    } = props
    const [startSpyHostService] = useStartSpyHostServiceMutation()
    const [stopSpyHostService] = useStopSpyHostServiceMutation()
    const rootClassName: string = `${styles.HostServiceCard_Root} ${hostServiceInformation.isMine ? '' : styles.HostServiceCard_Root__IsMine}`

    const handleStopSpy = async ()  => {
        await stopSpyHostService({
            hostServiceId: hostServiceInformation.id,
            marketSpyId: marketSpyId || -1
        })  
    }

    const handleStartSpy = async () => {
        const result =  await startSpyHostService({
            hostServiceId: hostServiceInformation.id,
            marketSpyId: marketSpyId || -1
        })

        onStartSpyHostService?.(result)
    }

    const spyButtonRender = () => {
        if (hostServiceInformation.propSpy === true) {
            return (
                <Button
                    color="success"
                    variant="outlined"
                    onClick={handleStopSpy}
                    sx={{
                        minWidth: 160,
                        minHeight: 48,
                        fontSize: '20px',
                        textTransform: 'none',
                        borderWidth: '2px!important',
                        background: `#FFFF`
                    }}
                >
                    Stop spy
                </Button >
            )
        }

        return (
            <Button
                color="success"
                variant="outlined"
                onClick={handleStartSpy}
                sx={{
                    minWidth: 160,
                    minHeight: 48,
                    fontSize: '20px',
                    textTransform: 'none',
                    borderWidth: '2px!important',
                    background: `#FFFF`
                }}
            >
                Spy it
            </Button >
        )
    }

    return (
        <div
            className={rootClassName}
        >
            <div className={styles.HostServiceCard_NameContainer}>
                <div className={styles.HostServiceCard_Name}>
                    {hostServiceInformation.name}
                </div>
            </div>

        
            <div className={styles.HostServiceCard_PictureContainer}>
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: '10px',
                    right: '10px',

                    zIndex: 1,
                }}
                >
                    <Box sx={{ padding: '6px 6px', backgroundColor: '#ffee33', display: 'flex', justifyContent: `space-between`, margin: '6px 6px' }}>
                        <Box sx={{ alignItems: `center`, display: `flex`, fontSize: '20px', fontWeight: 700, color: '#000', minWidth: '150px' }}>
                            <Box component="span">Position:</Box>
                            <Box component="span" sx={{ fontWeight: 400, marginLeft: '4px' }}>{hostServiceInformation.hostRank !== undefined ? hostServiceInformation.hostRank : ''}</Box>
                        </Box>
                    </Box>
                </Box>

                <picture>
                    <img
                        style={{ maxWidth: '100%', objectFit: 'cover', height: '440px', width: '100%', maxHeight: '440px' }}
                        src={hostServiceInformation?.strHostservicePictures?.[0]?.url}
                        alt=""
                        loading="lazy" />
                </picture>
            </div>
            <div className={styles.HostServiceCard_ActionListContainer}>
                <Link to={`/hostservice/${hostServiceInformation.id}?monitoridforprices=${marketSpyId}`}>
                    <Button
                        color="success"
                        variant="contained"
                        sx={{
                            minWidth: 160,
                            minHeight: 48,
                            fontSize: '20px',
                            textTransform: 'none'
                        }}
                    >
                        Details
                    </Button>
                </Link>
                {
                    spyButtonRender()
                }
            </div>
        </div>
    )
}